export default __webpack_public_path__ + "static/media/microsoft.5019fbb4.svg";